import { useMemo } from "react";
import {
  useGetPositionAndArenaDetailsQuery,
  useGetContactsByPositionQuery,
} from "~/graphql/supergraphHooks";

export const useProfileContacts = (profileId?: number, enabled: boolean = true) => {
  const profileQuery = useGetPositionAndArenaDetailsQuery({
    variables: { profileId: profileId ?? 0 },
    skip: !profileId || !enabled,
    fetchPolicy: "cache-and-network",
  });

  const profileData = profileQuery.data;

  const { arenaIds, positionIds } = useMemo(() => {
    const arenas = new Set<string>();
    const positions = new Set<string>();

    for (const position of profileData?.complianceProfile?.positions ?? []) {
      const arenaId = position?.arena?.id;
      const positionId = position?.id;
      if (arenaId) arenas.add(arenaId);
      if (positionId) positions.add(positionId);
    }

    return {
      arenaIds: Array.from(arenas),
      positionIds: Array.from(positions),
    };
  }, [profileData]);

  const contactsQuery = useGetContactsByPositionQuery({
    variables: { arenaIds, positionIds },
    skip: arenaIds.length === 0 || positionIds.length === 0 || !enabled,
    fetchPolicy: "cache-and-network",
  });

  const contactsData = contactsQuery.data;

  const emails = useMemo(() => {
    if (!contactsData?.positions?.edges) {
      return [];
    }

    const emailSet = new Set<string>();

    for (const edge of contactsData.positions.edges) {
      if (edge?.node?.contacts?.edges) {
        for (const contactEdge of edge.node.contacts.edges) {
          const primaryEmail = contactEdge?.node?.primaryEmail?.emailAddress;
          if (primaryEmail) {
            emailSet.add(primaryEmail);
          }
        }
      }
    }

    return Array.from(emailSet);
  }, [contactsData]);

  return {
    emails,
    profileQuery,
    contactsQuery,
  };
};
